import Layout from "./wrapPageElement"

export const wrapPageElement = Layout
